export class DeleteLottiGaraINModel {
    idLottiGara: number
}